import { render, staticRenderFns } from "./watch-list-management.vue?vue&type=template&id=71c7fa94&scoped=true"
import script from "./watch-list-management.vue?vue&type=script&lang=js"
export * from "./watch-list-management.vue?vue&type=script&lang=js"
import style0 from "./watch-list-management.vue?vue&type=style&index=0&id=71c7fa94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c7fa94",
  null
  
)

export default component.exports